export default Object.freeze([
  'Abuse',
  'Art',
  'Beauty',
  'Childhood',
  'Community',
  'Conquest',
  'Conspiracy',
  'Corruption',
  'Crime',
  'Death',
  'Desperation',
  'Diversity',
  'Economy',
  'Environment',
  'Family',
  'Food',
  'Friendship',
  'Gender',
  'Greed',
  'Health',
  'Hope',
  'Human Nature',
  'Human Rights',
  'Identity',
  'Immigration',
  'Inspiration',
  'LBGT',
  'Life & Society',
  'Loss',
  'Love',
  'Music',
  'Nature',
  'Other Worlds',
  'Parenting',
  'Perseverance',
  'Politics',
  'Poverty',
  'Reality',
  'Redemption',
  'Religion',
  'Revenge',
  'Sexuality',
  'Social Justice',
  'Technology',
  'Travel',
  'Youth',
]);



// WEBPACK FOOTER //
// ./src/assets/data/viddsee/tags.js